"use client";

import { c as _c } from "react/compiler-runtime";
import { metadata, type AITool } from "@app/_metadata";
import { CoreMetricsSheet } from "@shared-components/core-metrics-sheet";
import { ActiveFeatureFlags } from "@shared-components/global/active-feature-flags";
import { Ident } from "@shared-components/global/ident";
import { TopBarMenu } from "@shared-components/global/top-bar-menu";
import { UserDropdown } from "@shared-components/global/user-dropdown";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LanguageDropdown } from "@shared-components/language-dropdown";
import { DegradedFeatureFlagFallback } from "@shared-components/degraded-feature-flag-fallback";
interface TopBarProps {
  leftChildren?: React.ReactNode;
  rightChildren?: React.ReactNode;
  aiTools: AITool[];
  hideBottomBorder?: boolean;
}

/**
 * Topbar
 *
 * @param props TopBarProps
 */
export const TopBar = props => {
  const $ = _c(22);
  const path = usePathname();
  let t0;
  if ($[0] !== path) {
    t0 = metadata.aiTools?.find(appMeta => path.includes(appMeta.slug));
    $[0] = path;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeAiTool = t0;
  const t1 = `fixed left-0 top-0 z-50 flex h-14 w-full flex-row items-center justify-between bg-background px-2 sm:px-4 ${props.hideBottomBorder ? "" : "border-b border-border"}`;
  let t2;
  if ($[2] !== activeAiTool) {
    t2 = <Link href="/" className="w-[48px] sm:w-[233px] min-w-[48px]"><Ident aiTool={activeAiTool} /></Link>;
    $[2] = activeAiTool;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.leftChildren) {
    t3 = <DegradedFeatureFlagFallback><span className="hidden md:block">{props.leftChildren}</span></DegradedFeatureFlagFallback>;
    $[4] = props.leftChildren;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-row items-center min-w-0">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ActiveFeatureFlags />;
    t6 = <CoreMetricsSheet />;
    t7 = <LanguageDropdown />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeAiTool) {
    t8 = <TopBarMenu activeAiTool={activeAiTool} />;
    $[12] = activeAiTool;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <UserDropdown />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== props.rightChildren || $[16] !== t8) {
    t10 = <div className="flex flex-row items-center gap-1 sm:gap-2 min-w-0 flex-shrink">{t5}{t6}{t7}{props.rightChildren}{t8}{t9}</div>;
    $[15] = props.rightChildren;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t1 || $[19] !== t10 || $[20] !== t4) {
    t11 = <><div className={t1}>{t4}{t10}</div></>;
    $[18] = t1;
    $[19] = t10;
    $[20] = t4;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};